export default __webpack_public_path__ + "static/B0086-f4b13acf15c0a0218ab5afec5a039c19.png";